import { render, staticRenderFns } from "./login-modal.vue?vue&type=template&id=4235c412&"
import script from "./login-modal.vue?vue&type=script&lang=ts&"
export * from "./login-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports